import { __decorate, __metadata } from "tslib";
import { DataFrame, SerializableObject, SerializableMember } from '@openhps/core';
let ImageFrame = class ImageFrame extends DataFrame {
    /**
     * Height of image
     * @returns {number} Height
     */
    get rows() {
        return this.height;
    }
    set rows(value) {
        this.height = value;
    }
    /**
     * Width of image
     * @returns {number} Width
     */
    get cols() {
        return this.width;
    }
    set cols(value) {
        this.width = value;
    }
    /**
     * Source object clone that captured the data frame
     * @returns {CameraObject} Source data object
     */
    get source() {
        return super.source;
    }
    /**
     * Set the source object clone that captured the data frame
     * @param {CameraObject} object Source data object
     */
    set source(object) {
        super.source = object;
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", Object)
], ImageFrame.prototype, "image", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], ImageFrame.prototype, "height", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], ImageFrame.prototype, "width", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], ImageFrame.prototype, "fourcc", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], ImageFrame.prototype, "fps", void 0);
ImageFrame = __decorate([
    SerializableObject()
], ImageFrame);
export { ImageFrame };
//# sourceMappingURL=ImageFrame.js.map